export default function wakeUp() {
    //Wakes up the backend
    return fetch(`${process.env.REACT_APP_API_BASE_URL}/api/heartbeat`, {
        method: 'GET',
        mode: 'cors',
        cache: 'no-cache',
    }).catch((error) => {
        console.error(error);
    })
}
